module.exports = __webpack_public_path__ + "img/_0.49c31fef.png";